import { _ } from "../../../../core/polyglot/polyglot.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import ReportDisplaySettingsForm from "../../../../core/widgets/ReportDisplaySettingsForm/ReportDisplaySettingsForm.js";
import SwitchButton from "../../../../core/widgets/SwitchButton/SwitchButton.js";

/**
 * Widget displaying settings for the current report.
 *
 * @param {boolean} isInSaveSpaceMode - State for save space mode
 * @param {ReportDisplaySettings} reportDisplaySettings - Current report display settings
 * @param {function} onChange - Function called with report and report's settings
 * @param {function} onSaveSpaceModeChange - Function called with
 *   new value to set
 * @param {boolean} showCreditPositiveSwitch - If true the display settings form renders
 *   a credit positive switch
 */
export default class ForecastDisplaySettingsWidget extends Widget {
	constructor({
		isInSaveSpaceMode,
		reportDisplaySettings,
		onChange,
		onSaveSpaceModeChange,
		showCreditPositiveSwitch,
	} = {}) {
		super(...arguments);

		this._isInSaveSpaceMode = isInSaveSpaceMode;
		this._reportDisplaySettings = reportDisplaySettings;
		this._onChange = onChange;
		this._onSaveSpaceModeChange = onSaveSpaceModeChange;

		this._reportDisplaySettingsForm = new ReportDisplaySettingsForm({
			reportDisplaySettings: this._reportDisplaySettings,
			onChange: this._onChange,
			showCreditPositiveSwitch,
		});

		this._saveSpaceSwitchButton = new SwitchButton({
			dataTestName: "save-space-mode",
			state: this._isInSaveSpaceMode,
		});

		this._saveSpaceSwitchButton.stateChanged.register(
			this._onSaveSpaceModeChange,
		);
	}

	renderContentOn(html) {
		html.div(
			{ class: "display-settings" },
			html.h2(_("Display Settings")),
			this._reportDisplaySettingsForm,
			this._renderSaveSpaceModeOn.bind(this),
		);
	}

	_renderSaveSpaceModeOn(html) {
		html.div(
			{
				class: "form-horizontal",
			},
			html.div(
				{ class: "form-group" },
				html.label(
					{ class: "control-label col-sm-2" },
					_("Save Space Mode"),
				),
				html.div(
					{
						class: "col-sm-10",
					},
					this._saveSpaceSwitchButton,
				),
			),
		);
	}
}
